<template>
    <div class="pay">
        <div class="title">{{title}}</div>
        <div class="subtitle">支付方式</div>
        <div class="pay-type">
            <div class="pay-option" @click="onCheck(1)">
                <div class="pay-title">
                    <span><van-icon name="/pay/weixin.png"/></span><span style="padding-left: 20px">微信</span>
                </div>
                <div class="pay-value"><van-checkbox icon-size="18px" checked-color="#ee0a24" v-model="wx"/></div>
            </div>

            <div class="pay-option" @click="onCheck(2)">
                <div class="pay-title">
                    <span><van-icon name="/pay/zfb.png"/></span><span style="padding-left: 20px">支付宝</span>
                </div>
                <div class="pay-value"><van-checkbox icon-size="18px" checked-color="#ee0a24" v-model="zfb"/></div>
            </div>
        </div>

    </div>
    <div class="footer">
        <div class="total">合计 <span style="color: #F94B54"> {{order_money}} 元</span></div>
        <div class="payment" @click="onPayment">确认支付</div>
    </div>
</template>
<script>

import wx from "weixin-js-sdk";
import ayzAjax from "@/plugins/axios";
import {closeToast, showFailToast, showLoadingToast} from "vant";
export default {
    name: "PayView",
    data: function () {
        return {
            title:'爱驿站支付页面',
            order_money:0,
            wx:true,
            zfb:false,
            type:1,
            params:[],
            // props:['business_type','activity_id','userid','token']
            //:business_type/:activity_id/:userid/:token
        }
    },
    created() {
        this.params = this.$route.params;
        console.log(this.params);
        this.getActivity();
    },
    methods: {
        getActivity(){
            try {
                let url = '/checkout/index?buyer_id=' + this.params.userid + '&buyer_token=' + this.params.token + '&business_type=' + this.params.business_type + '&activity_id=' + this.params.activity_id;
                ayzAjax.get(url).then((response) => {
                    if(response.data.code !== 200){
                        showFailToast(response.data.msg);
                        return false;
                    }
                    this.order_money = response.data.data.order_money;
                    this.title = response.data.data.order_title;
                    console.log(response.data);
                })
            }catch(err) {
                console.log(err);
                showFailToast('网络错误,请稍后再试')
            }
        },
        onCheck(type){
            this.type = type;
            if(type === 1){
                this.wx = true;
                this.zfb = false;
            }else{
                this.wx = false;
                this.zfb = true;
            }
        },
        onPayment() {
            showLoadingToast({
                duration: 0,
                loadingType: 'spinner',
            });
            if (this.type === 1) {
                console.log('微信支付开发中');
            }
            if (this.type === 2) {
                try {
                    let url = '/checkout/get_ali_pay_info?buyer_id=' + this.params.userid + '&buyer_token=' + this.params.token + '&business_type=' + this.params.business_type + '&activity_id=' + this.params.activity_id;

                    ayzAjax.get(url).then((response) => {
                        if(response.data.code !== 200){
                            showFailToast(response.data.msg);
                            return false;
                        }
                        closeToast();
                        let page_data = response.data.data.page_data;
                        try {
                            const formdiv = document.createElement('formdiv');
                            formdiv.innerHTML = page_data;
                            document.body.appendChild(formdiv);
                            document.forms[0].setAttribute('target', '_self');
                            document.forms[0].submit();
                            formdiv.remove();
                        }catch(err) {
                            showFailToast('支付宝拉起失败,请稍后再试');
                            console.log(err);
                        }
                    })
                }catch(err) {
                    console.log(err);
                    showFailToast('网络错误,请稍后再试')
                }
            }

        },
        wexinPay(data) {
            //获取后台传入的数据
            let {appId, timestamp ,nonceStr ,signature ,packages ,paySign,signType  } = data;
            //发起微信支付
            wx.config({
                debug: false, // 开启调试模式
                appId: appId, // 必填，公众号的唯一标识
                timestamp: timestamp, // 必填，生成签名的时间戳
                nonceStr: nonceStr, // 必填，生成签名的随机串
                signature: signature, // 必填，签名
                jsApiList: ['chooseWXPay'] // 必填，需要使用的JS接口列表
            });
            wx.ready(function () {
                wx.chooseWXPay({
                    timestamp: timestamp, // 支付签名时间戳
                    nonceStr: nonceStr, // 支付签名随机串，不长于 32 位
                    package: packages, // 统一支付接口返回的prepay_id参数值，提交格式如：
                    signType: signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                    paySign: paySign, // 支付签名
                    success: function (res) {
                        // 支付成功后的回调函数
                        console.log(res);
                    },
                    fail: function (res) {
                        //失败回调函数
                        console.log(res);
                    }
                });
            });
            wx.error(function (res) {
                console.log(res);
                alert("config信息验证失败");
            });
        }


    }
}
</script>

<style scoped lang="scss" >
.pay{
    margin-top: 0;
    background: #FFFFFF;
    padding: 40px 20px 40px 30px;
    .title{
        color: #333333;
        font-size: 17px;
        font-weight: bold;
    }
    .subtitle{
        //margin-top: 20px;
        color: #121212;
        font-size: 15px;
        text-align: left;
        font-weight: bold;
        margin-top: 30px;
    }
    .pay-type{
        margin-top: 20px;
        text-align: left;
        .pay-option{
            margin-top: 20px;
            width: 100%;
            height: 30px;
            line-height: 30px;
            .pay-title{
                width: 150px;
                float: left;
            }
            .pay-value{
                width: 40px;
                float: right;
                margin-top: 8px;
            }
        }
    }

}
.footer{
    position: fixed;
    bottom: 0px;
    width: 100%;
    //display: flex;
    font-size: 18px;
    font-weight: bold;
    text-align: left;
    padding-left: 30px;
    color: #222222;
    line-height: 50px;
    background: #FFFFFF;
    padding-top: 10px;
    padding-bottom: 10px;
    .total{
        //margin-top: 20px;
        float: left;
    }
    .payment{
        float: right;
        //margin-top: 20px;
        margin-right: 60px;
        width: 160px;
        height: 48px;
        line-height: 48px;
        background-color: #F94B54;
        color: #FFFFFF;
        text-align: center;
        border-radius: 10px;
    }

}



</style>